export default __webpack_public_path__ + "static/media/envsensor_realtime_noise.bbd77ac7.svg";